import BaseApi from '../BaseApi';
import { AgentAdminConverter } from './AgentAdminConverter';

class AgentAdminApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin`;
    this.converter = new AgentAdminConverter();
  }

  getFeedbackLink = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/feedback_link/`,
      null,
      null,
      this.converter.convertFeedbackLink,
    );

  updateFeedbackLink = link =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/feedback_link/update`, { link: link });

  getNotifications = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/notifications`,
      null,
      null,
      this.converter.convertNotifications,
    );

  dropNotification = id =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/notifications`, { notification_id: id });

  getRankings = date =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/ranking`,
      date ? { date_month: date } : null,
      null,
      this.converter.convertRankings,
    );

  getRubyPlayRanking = date =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/rubyplay_ranking`,
      date ? { date_month: date } : null,
      null,
      this.converter.convertRankings,
    );

  getPragmaticRanking = ({ date, type }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/pragmatic_ranking`,
      { provider: type, date_month: date },
      null,
      this.converter.convertRankings,
    );

  getBetsLimits = () =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/bet_limits`, null, null, this.converter.convertBetsLimits);

  postBetsLimits = data =>
    this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl}/bet_limits`,
      {
        slots_bet_limit: data.slots,
        live_casino_bet_limit: data.liveCasino,
        sport_bet_limit: data.digsport,
      },
      null,
      this.converter.convertBetsLimits,
    );

  getDomains = () =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/domain_request`, null, null, this.converter.convertDomains);

  getMyDomains = params =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/agent_domains`, params, null, this.converter.convertMyDomains);

  sendDomainRequest = data =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/domain_request`, { domain_name: data }, null);

  createRevshareDepositPreorder = ({ amount }) =>
    this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl}/revshare/deposit/preorder`,
      { amount },
      null,
      this.converter.convertRevshareDepositPreorder,
    );

  confirmRevshareDeposit = ({ requestId, amount }) =>
    this.sendQuery(
      this.queryTypes.PUT,
      `${this.baseUrl}/revshare/deposit`,
      { request_id: requestId, amount },
      null,
      this.converter.convertRevshareDeposit,
    );
}

export default AgentAdminApi;
